const TYPE = "saldoReserva";

const saldoReservaModule = {
  update: async (dbConnection, idProduto, idPedido, qtd) => {
    let saldoReserva = await getDocSaldoReserva(dbConnection, idProduto);

    saldoReserva.pedidos.push({
      _id: idPedido,
      qtd: qtd
    });

    await dbConnection.put(saldoReserva);
  },

  getSaldoReserva: async (dbConnection, idProduto) => {
    let saldoReserva = await getDocSaldoReserva(dbConnection, idProduto);

    let total = {
      qtd: 0
    };

    if (saldoReserva.pedidos.length) {
      for (let pedido of saldoReserva.pedidos) {
        total.qtd += pedido.qtd;
      }
    }

    return total;
  },

  removeSaldoReserva: async (dbConnection, idProduto, idPedido) => {
    let saldoReserva = await getDocSaldoReserva(dbConnection, idProduto);
    let qtdPedidos = saldoReserva.pedidos.length;
    let pedidos = saldoReserva.pedidos.filter((item) => item._id !== idPedido);
    saldoReserva.pedidos = pedidos;

    if(saldoReserva.pedidos.length !== qtdPedidos){
      await dbConnection.put(saldoReserva);
    }    
  },
};

const getDocSaldoReserva = async (dbConnection, idProduto) => {
  let saldoReserva = null;
  const query = {
    selector: {
      type: { $eq: TYPE },
      "produto._id": { $eq: idProduto },
    },
    limit: 1,
  };

  let result = await dbConnection.find(query);

  if (result.docs.length) {
    saldoReserva = result.docs[0];
  } else {
    await dbConnection.post({
      type: TYPE,
      produto: { _id: idProduto },
      pedidos: [],
    });
    result = await dbConnection.find(query);
    if (result.docs.length) {
      saldoReserva = result.docs[0];
    } else {
      throw new Error("Não foi possível gravar o saldo reserva");
    }
  }

  return saldoReserva;
};

export default saldoReservaModule;
